import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { tc } from '../../lib/trackingContext';
import { useOrderSummary } from '../useOrderSummary';

export const useSecondPaymentCompletedTracking = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderItems } = useOrderSummary(orderNumber);

  const trackSecondPaymentCompleted = useCallback(
    result => {
      tc.track('Second Payment Completed', {
        addToScopeOnce: {
          order: result.data.chargeOrder.data[0],
          products: orderItems
        }
      });
    },
    [orderItems]
  );

  return { trackSecondPaymentCompleted };
};
